let windowLoading = null

export const loadmodal = {
  open,
  close
}

function open() {
  if (windowLoading == null) {
    windowLoading = create()
  }
  windowLoading.open()
}

function close() {
  windowLoading.close()
}

function create() {
  console.log("syda")
  const win = document.createElement('div')
  const container = document.createElement('div')
  container.setAttribute('id', 'window_loading_modal')
  win.setAttribute('class', 'loading')
  document.body.prepend(container)
  container.appendChild(win)
  return new function() {
    this.open = function() {
      console.log('open')
      container.classList.add('show')
    }

    this.close = function() {
      console.log('close', window)
      container.classList.remove('show')
    }
  }
}